import orderRefund from '@/pages/components/orderRefund/orderRefund.vue'
import { testEfficacy } from '@/utils'
export default {
	components: {
		orderRefund
	},
	data() {
		return {
			refundVisible: false
		}
	},
	methods: {
		refundSuccess() {
			this.getOrderInfos(false)
		},
		refundFun(row) {
			console.log(row)
			this.detail_id = row.id
			testEfficacy({
				loseEfficacy: () => {
					this.$testPhone({
						success: () => {
							this.refundVisible = true
						}
					})
				},
				effective: () => {
					this.refundVisible = true
				}
			})
			
		}
	}
} 
